import { render, staticRenderFns } from "./setting-pay.vue?vue&type=template&id=42954554&scoped=true&"
import script from "./setting-pay.vue?vue&type=script&lang=js&"
export * from "./setting-pay.vue?vue&type=script&lang=js&"
import style0 from "./setting-pay.vue?vue&type=style&index=0&id=42954554&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42954554",
  null
  
)

export default component.exports